import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h2>About</h2>
        <p className='text-justify'>Chendur Vishakan Bio Energy (P) Ltd. is an innovative renewable energy company based in Thoothukudi, Tamil Nadu, producing Compressed Bio-Gas (CBG) and organic by-products from food and agricultural waste. We specialize in decentralized waste-to-energy solutions for rural and semi-urban industries.</p>
      </div>
      <div className="about-features">
        <div className="feature-card">
          <h3>Our Mission</h3>
          <p>Develop and deploy cost-effective, safe, and scalable CBG systems.Promote waste-to-energy technologies that cut carbon emissions.Empower industries and MSMEs with reliable low-pressure biogas.Drive continuous improvement through research and technology.
</p>
        </div>
        <div className="feature-card">
          <h3>Our Vision</h3>
          <p>To be a national leader in sustainable energy innovation by transforming organic waste into renewable fuel and fostering a cleaner, energy-efficient India.</p>
        </div>
        <div className="feature-card">
          <h3>Who We Are</h3>
          <p>Chendur Vishakan Bio Energy (P) Ltd is a forward-thinking renewable energy enterprise that transforms organic waste into valuable energy solutions. Established by three visionary directors —<b> Priya (Managing Director), Revathy (Technical Director), and Dhanalaxmi (Executive Director – Operations)</b> our company embodies innovation, inclusivity, and environmental responsibility.
Together, we are committed to building a cleaner, greener, and energy-secure India through modern waste-to-energy technologies.
</p>
        </div>
        <div className="feature-card">
          <h3>What We Do</h3>
          <p>We specialize in the production of Compressed Biogas (CBG/Bio-CNG) and organic bio-fertilizers through sustainable anaerobic digestion technology. Our unique low-pressure CBG delivery model eliminates heavy CAPEX requirements, providing MSMEs and industrial clients with affordable clean energy and a sustainable alternative to fossil fuels.
By converting biodegradable waste into clean energy and natural fertilizers, we help businesses reduce carbon emissions, improve resource efficiency, and contribute to a circular green economy.
</p>
        </div>
      </div>
      <div className="about-why">
        <h3 className="why-title">Why Choose Us</h3>
        <p className="why-subtitle">Green Energy for a Cleaner Future — decentralized waste-to-energy, Made in India.</p>
        <div className="why-grid">
          <div className="why-item">
            <div className="why-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                <polyline points="17 6 23 6 23 12"/>
              </svg>
            </div>
            <h4>Cost-effective green energy with zero heavy CAPEX</h4>
          </div>
         
          <div className="why-item">
            <div className="why-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2.69l-7.17 7.17a7 7 0 1011.31 0L12 2.69z"/>
              </svg>
            </div>
            <h4>100% sustainable and locally sourced feedstocks</h4>
          </div>
          <div className="why-item">
            <div className="why-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M11 3a7 7 0 017 7 7 7 0 01-7 7H7a7 7 0 010-14h4"/>
                <line x1="12" y1="20" x2="21" y2="11"/>
              </svg>
            </div>
            <h4>Dual revenue stream through renewable gas and biofertilizer</h4>
          </div>
          <div className="why-item">
            <div className="why-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
              </svg>
            </div>
            <h4>Women-led leadership promoting inclusive green entrepreneurship</h4>
          </div>
        </div>
      </div>

      {/* Technologies & Innovations moved under Services */}
    </div>
  );
};

export default About;
